import { useEffect, useState, useRef} from "react";
import "./MahutiContrastToggler.css"
import { isMobile } from "react-device-detect";
import { useLocation } from "react-router-dom";

export default function MahutiContrastToggler({contrastTogglerRef}) {
    const location = useLocation();

    const [highContrast, setHighContrast] = useState(
        localStorage.getItem("highContrast") === "true"
    );

    useEffect(() => {
        if (highContrast) {
            document.documentElement.classList.add("high-contrast");
        } else {
            document.documentElement.classList.remove("high-contrast");
        }
        localStorage.setItem("highContrast", highContrast);
    }, [highContrast]);

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setHighContrast(!highContrast);
        }
    };

    return <div 
                ref={contrastTogglerRef}
                onClick={() => setHighContrast(!highContrast)}
                onKeyDown={handleKeyDown}
                className="contrast-toggler me-3"   
                role="button"              
                aria-pressed={highContrast}
                aria-label="שינוי ניגודיות צבעים באתר"
                tabIndex="0"
            >change contrast</div>
}